module.exports = __webpack_public_path__ + "static/media/service.9fa23883.png";